import React, { memo } from 'react';
import { withRouter } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { useTranslation } from 'react-i18next';
import styles from './back.module.scss';

export default memo(withRouter(function Back(props) {
    const { t } = useTranslation('common');

    const handleClick = () => props.history.push(props.url);

    return (
        <div className={styles.container}>
            <div className={styles.optionContainer} onClick={handleClick}>
                <SVG cacheGetRequests className={styles.icon} src="./icons/back.svg" />
                <span>{t('BACK')}</span>
            </div>
        </div>
    );
}));
